import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './auth'
import LoginPage     from './pages/LoginPage'
import DashboardPage from './pages/DashboardPage'
import UploadPage    from './pages/UploadPage'
import EmailListPage from './pages/EmailListPage'
import LogsPage      from './pages/LogsPage'
import UsersPage     from './pages/UsersPage'

export default function App() {
  const { account, ready } = useAuth()

  if (!ready) return null

  if (!account) return <LoginPage />

  return (
    <Routes>
      <Route path="/"           element={<DashboardPage />} />
      <Route path="/upload"     element={<UploadPage />} />
      <Route path="/email-list" element={<EmailListPage />} />
      <Route path="/logs"       element={<LogsPage />} />
      <Route path="/users"      element={<UsersPage />} />
      <Route path="*"           element={<Navigate to="/" />} />
    </Routes>
  )
}
